import "@babel/polyfill";

class dataServices{
    constructor(){
        this.baseAddress = '/modService/ListController/GetModItems?webUrl='; // '/_api/Web/Lists/GetByTitle';
    }
    //http://edit.weaponsd3.mod.gov.il/modService/ListController/GetModItems?webUrl=http://edit.weaponsd3.mod.gov.il&listName=%D7%94%D7%95%D7%93%D7%A2%D7%95%D7%AA&viewName=All%20Items
   
getSPListItems(siteUrl,listName,viewName){
     //   const address = `${this.baseAddress}('${listName}')/Items?$select=${fileds.join(',')}`;
     listName = encodeURIComponent(listName);
     viewName = encodeURIComponent(viewName);
        const address = `${this.baseAddress}${siteUrl}&listName=${listName}&viewName=${viewName}`;
        return axios.get(address);
    }
}

export default new dataServices(); 